import React, {useState} from "react"
import prosAppNotif from "../prodect/ProsAppNotif";

/**
 * @param confirm       Boolean, does action need to be confirmed
 * @param action        function to be called when clicked
 * @param class         primary, secondary, 3rd,
 * @param type          warning, prompt, required
 * @param required      boolean
 * @param label         button text
 * @param icon          btn-icon-?
 * @param selected      btn-state-selected
 * @returns {JSX.Element}
 * @constructor
 */

export default function BasicButton(props) {
        const CustomTag = (props.customTag || (props.href ? 'a' : 'button'))//<button> by default
        if(props.type) console.log("usage of 'type', use btnType instead. ")
        return <CustomTag
            href={props.href || null}
            download={props.download ? true : null}
            target={props.target || null}
            rel={props.href ? "noopener noreferrer" : null}
            onMouseDown={props.onMouseDown || null}
            tabIndex={props.tabIndex || null}
            onClick={(evt)=>{
                if(!props.action || props.disabled) return//has to be first, so that won't prevent default for form submission
                evt.preventDefault()
                evt.stopPropagation()
                if(props.btnType === "locked"){
                    prosAppNotif( props.notifMsg || "Ei käyttöoikeuksia", {type: "notice"})
                    return
                }
                //this is not doing anything as button is disabled?//leaving here because too close to release
                if(props.disabled){
                    prosAppNotif( props.notifMsg || "Ei käytössä", {type: "notice"})
                    return
                }
                if(typeof props.action === 'function') props.action(evt)
            }}
            type={props.buttonType || null}
            disabled={props.disabled || false}
            title={props.title || null}
            value={props.value || null}
            style={props.style}
            data-tooltip={props.tooltip ? props.tooltip[0] : null}
            className={"btn" + ((props.btnClass !== "" ? " btn-" + (props.btnClass ? props.btnClass : "3rd") : ""))
                + (props.btnType ? " btn-type-" + props.btnType : "")
                + (props.required ? " btn-type-required" : "")
                + (props.size && props.size ? " btn-" + props.size : "")
                + (props.label && props.icon ? " btn-icon-" + (props.iconPosition || "left") : "")
                + (props.icon ? " btn-icon btn-icon-" + (props.icon || "check") + (props.hilite ? "_color-main" : "") : "")
                + (props.iconColor ? "_color-" + props.iconColor : "")
                + (props.icon && props.iconSize ? " btn-icon-" + props.iconSize : "")
                + (props.selected ? " btn-state-selected" : "")
                + (props.loading ? " btn-state-loading" : "")
                + (props.shrink && props.icon ? " btn-shrink_" + props.shrink : "")//is for removing text on small screens
                + (props.className ? " " + props.className : "")
                + (props.tooltip && props.tooltip[1] ? " tooltip " + props.tooltip[1] : "")//tooltip classNames
            }
        >
        {props.tag && <i className={"btn-tag" + (typeof props.tag === 'object' ? " has-child" : "")}>{typeof props.tag !== 'boolean' ? props.tag : null}</i>}
        <span className={props.hilite ? "color-main" : null}>{props.label || null}</span>
        {props.children}
    </CustomTag>
}

export function ConfirmButton(props) {
    const [confirm, setConfirm] = useState(false)
    let icon = props.icon  || null
    let label = props.label || "Tallenna"
    if(props.btnType === 'cancel'){
        icon = "times"
        label = "Peru"
    }
    if(props.btnType === 'fatal'){
        icon = props.icon || "delete"
        label = typeof props.label === 'boolean' ? null : props.label || "Poista"
    }
    if(props.hideLabel) label = null
    if(!icon) icon = "check"
    return <BasicButton
            btnClass={props.btnClass || "primary"}
            icon={icon}
            label={label}
            action={()=> {
                if(props.confirmAction && !confirm){
                    setConfirm(true)
                    return
                }
                if(typeof props.action === 'function' && !confirm){
                    props.action()
                    setConfirm(false)
                }
            }}
            disabled={props.disabled}
            tooltip={props.tooltip}
            size={props.size}
            shrink={props.shrink}
            className={"btn-" + (props.btnType || "confirm")
                + (props.confirmAction && confirm ? " btn-confirm-enabled" : "")}
            loading={props.loading}
        >
        {props.confirmAction && confirm ? <div className={"element-set-v" + (props.direction ? " " + props.direction : "")}>
            <BasicButton
                customTag={"a"}
                btnClass={"primary"}
                label={props.hideLabel ? null : "Vahvista"}
                icon={"check"}
                disabled={false}
                action={()=> {
                    props.action()
                    setConfirm(false)
                }}
                size={props.size}
                shrink={props.shrink}
                className={"btn-confirm"}
                tooltip={props.confirmMessage && confirm ? [props.confirmMessage, "tooltip-top"] : null}
            />
            <BasicButton
                customTag={"a"}
                btnClass={"primary"}
                label={props.hideLabel ? null : props.cancelLabel || "Peru"}
                icon={"times"}
                disabled={false}
                action={()=> {
                    setConfirm(false)
                }}
                size={props.size}
                shrink={props.shrink}
                className={"btn-cancel"}
            />
            </div> : null}
    </BasicButton>
}

export function CancelButton(props) {
    return <ConfirmButton
        btnType={"cancel"}
        label={props.label || "Peru"}
        icon={props.icon  || "times"}
        action={()=> props.action() || {}}
        tooltip={props.tooltip}
        size={props.size}
        shrink={props.shrink}
    />
}